export default __webpack_public_path__ + "static/media/step2done.fe209b9f.png";